import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { fdt } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import { hasPerm } from "@/lib/perms";
import { AlertTriangle } from "lucide-react";

const ISSUE = { no_vet: "No vet assigned", not_a_vet: "Assigned to a non-vet profile" };

// Open consultations no vet can see on their dashboard (missing/invalid vet) — fix via Assign / Staff plan.
export function VetAssignmentAlert() {
  const { user } = useAuth();
  const allowed = hasPerm(user, "bookings.create") || hasPerm(user, "vet.supervise");
  const { data } = useQuery({ queryKey: ["vet-assignment-issues"], enabled: allowed, refetchInterval: 60000, retry: false,
    queryFn: async () => (await api.get("/veterinary/assignment-issues")).data });
  const items = data?.items || [];
  if (!allowed || (!items.length && !data?.unsynced_bookings)) return null;
  return (
    <div className="mb-4 rounded-2xl border border-amber-200 bg-amber-50 p-4" data-testid="vet-assignment-alert">
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900"><AlertTriangle className="h-4 w-4" />
        {items.length} vet appointment{items.length === 1 ? "" : "s"} not visible to any vet{data?.unsynced_bookings ? ` · ${data.unsynced_bookings} vet booking(s) without a consultation record` : ""}</p>
      <ul className="mt-2 space-y-1 text-xs text-amber-900">{items.slice(0, 5).map((e) => (
        <li key={e.id} data-testid={`vet-assignment-issue-${e.id}`}>{fdt(e.visit_date)} · {e.pet_name || "Pet"} · {e.customer_name || "—"} — <b>{ISSUE[e.issue]}</b>{e.veterinarian ? ` (${e.veterinarian})` : ""}</li>))}</ul>
      <p className="mt-2 text-xs text-amber-800">Assign a vet with "Assign" or the Staff plan on the booking so it appears on that vet's dashboard.</p>
    </div>
  );
}
